import Vue from "vue";
import Router from "vue-router";

import Stories from "./views/Stories/Stories.vue";
import Home from "./views/Home/Home.vue";
import Data from "./views/Data/Data.vue";
import Tchaer from "./views/Tchaer/Tchaer.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/stories",
      name: "stories",
      component: Stories
    },
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/data",
      name: "data",
      component: Data
    },
    {
      path: "/tchaer",
      name: "tchaer",
      component: Tchaer
    }
  ]
});
